export default __webpack_public_path__ + "static/media/alpha.48bcd854.jpg";